export default __webpack_public_path__ + "static/homepageCulture-fd2db2da4dd9225d1a3680626ff52704.svg";